import { render } from "./ShoppingList.vue?vue&type=template&id=bf88a2c8&scoped=true"
import script from "./ShoppingList.vue?vue&type=script&lang=js"
export * from "./ShoppingList.vue?vue&type=script&lang=js"

import "./ShoppingList.vue?vue&type=style&index=0&id=bf88a2c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf88a2c8"]])

export default __exports__